import { Link } from "react-router-dom";
import classNames from "classnames";
import CalculatorMenuLink from "../calculators/CalculatorMenuLink";

const SideBarNavLinks = ({ isExpanded, styles }) => {
  const mainNavItems = [
    {
      id: "guidelines",
      icon: "tg-icons-Guidelines",
      title: "Guidelines",
      path: "/guidelines/",
      style: styles.largeIcon
    },
    {
      id: "calculators",
      icon: "tg-icons-Calculator",
      title: "Calculators",
      path: "/calculator/",
      style: styles.icon
    },
    {
      id: "resources",
      icon: "tg-icons-Resources",
      title: "Resources",
      path: "/resources/",
      style: styles.smallIcon
    },
    {
      id: "favourites",
      icon: "tg-icons-Favourite",
      title: "Favourites",
      path: "/favourites/",
      style: styles.largeIcon
    },
  ];

  return (
    <nav className={classNames(styles.mainNav, { [styles.expandedMainNav]: isExpanded })}>
      {mainNavItems.map((item) => {
        // Use CalculatorMenuLink for calculator navigation to enable modal behavior
        if (item.id === "calculators") {
          return (
            <CalculatorMenuLink
              key={item.id}
              className={classNames(styles.navItem, { [styles.expandedNavItem]: isExpanded })}
              title={item.title}
            >
              <i className={classNames(item.style, item.icon)}></i>
              {isExpanded && (
                <span className={classNames("size-16 semi-bold", styles.linkText)}>{item.title}</span>
              )}
            </CalculatorMenuLink>
          );
        }
        
        // Use regular Link for other navigation items
        return (
          <Link
            key={item.id}
            to={item.path}
            className={classNames(styles.navItem, { [styles.expandedNavItem]: isExpanded })}
            title={item.title}
          >
            <i className={classNames(item.style, item.icon)}></i>
            {isExpanded && (
              <span className={classNames("size-16 semi-bold", styles.linkText)}>{item.title}</span>
            )}
          </Link>
        );
      })}
    </nav>
  );
};

export default SideBarNavLinks;
